<template>
    <div class="monitor-warp">
        <div class="top">
            <div class="f-c-b">
                <item nub="1" text="加热系统监测" :list="_leftList" />
                <monitorMap />
                <item nub="2" text="净水器监测系统" :list="_rightList" />
            </div>
            <bottom :list="_bottomList" />
        </div>
    </div>
</template>

<script>
    import item from './item.vue'
    import monitorMap from './map.vue'
    import bottom from './bottom.vue'
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        components: {
            item,
            monitorMap,
            bottom
        },
        computed: {
            _leftList() {

                let Data = {
                    num1: 0,
                    num2: 0
                }

                if (this.Data && this.Data.data1) {
                    Data = Object.assign(Data, this.Data.data1)
                }

                let list = this.leftList.map(i => {

                    let value = Data.hasOwnProperty(i.key) ? parseInt(Data[i.key]) : 0

                    const config = {
                        number: [value],
                        content: '{nt}',
                        formatter: this.formatter,
                        style: {
                            fontSize: 28,
                            fill: '#0fc4ff',
                            fontStyle: 'italic',
                            letterSpacing: '1px'
                        },
                    }

                    return {
                        ...i,
                        value,
                        config
                    }
                })
                return list
            },
            _rightList() {

                let Data = {
                    num1: 0,
                    num2: 0
                }

                if (this.Data && this.Data.data2) {
                    Data = Object.assign(Data, this.Data.data2)
                }

                let list = this.rightList.map(i => {

                    let value = Data.hasOwnProperty(i.key) ? parseInt(Data[i.key]) : 0

                    const config = {
                        number: [value],
                        content: '{nt}',
                        formatter: this.formatter,
                        style: {
                            fontSize: 28,
                            fill: '#0fc4ff',
                            fontStyle: 'italic',
                            letterSpacing: '1px'
                        },
                    }

                    return {
                        ...i,
                        value,
                        config
                    }
                })
                return list
            },
            _bottomList() {

                let Data = {
                    num1: 0,
                    num2: 0,
                    num3: 0,
                    num4: 0
                }

                if (this.Data && this.Data.data3) {
                    Data = Object.assign(Data, this.Data.data3)
                }

                let list = this.bottomList.map(i => {

                    let value = Data.hasOwnProperty(i.key) ? parseInt(Data[i.key]) : 0

                    const config = {
                        number: [value],
                        content: '{nt}',
                        formatter: this.formatter,
                        style: {
                            fontSize: 28,
                            fill: '#0fc4ff',
                            fontStyle: 'italic',
                            letterSpacing: '1px'
                        },
                    }

                    return {
                        ...i,
                        value,
                        config
                    }
                })
                return list
            }

        },
        data() {
            return {
                leftList: [{
                        name: '设备总加热时长/天',
                        value: 0,
                        key: 'num1'
                    },
                    {
                        name: '加热继电器/次',
                        value: 0,
                        key: 'num2'
                    }
                ],
                rightList: [{
                        name: '滤芯正常/台',
                        value:0,
                        key: 'num1'
                    },
                    {
                        name: '滤芯到期/台',
                        value: 0,
                        key: 'num2'
                    }
                ],
                bottomList: [{
                        name: '智能触摸按键/次',
                        value: 0,
                        key: 'num1'
                    },
                    {
                        name: '进水电磁阀门/次',
                        value: 0,
                        key: 'num2'
                    },
                    {
                        name: '净水高压开关/次',
                        value: 0,
                        key: 'num3'
                    },
                    {
                        name: '放水电磁阀门/次',
                        value: 0,
                        key: 'num4'
                    }
                ]
            }
        },
        methods: {
            formatter(number) {
                const numbers = number.toString().split('').reverse()
                const segs = []
                while (numbers.length) segs.push(numbers.splice(0, 3).join(''))
                return segs.join(',').split('').reverse().join('')
            }
        }
    }
</script>

<style lang="less" scoped>
    .monitor-warp {
        .f-c-b {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

    }
</style>
